export const getMinWidth = (activeTab) => {
    switch (activeTab) {
        case 'day':
            return 23;
        case 'week':
            return 11;
        case 'month':
            return 7;
        default:
            return 23;
    }
};
